export default class EmailNotificationBaseService {}
